import { ArrowRight, Search, X } from 'lucide-react';
import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCommerce } from '../contexts/CommerceContext';
import { imageSource } from '../lib/assets';

export function SearchModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [query, setQuery] = useState('');
  const { products } = useCommerce();
  const results = useMemo(() => {
    const normalized = query.trim().toLocaleLowerCase('pt-BR');
    if (!normalized) return products.filter((product) => product.featured).slice(0, 4);
    return products.filter((product) => [product.name, product.category, product.collection, ...product.tags, ...product.colors.map((color) => color.name)].join(' ').toLocaleLowerCase('pt-BR').includes(normalized)).slice(0, 6);
  }, [products, query]);

  if (!open) return null;
  return <div className="search-modal" role="dialog" aria-modal="true" aria-label="Buscar produtos">
    <button className="page-scrim" aria-label="Fechar busca" onClick={onClose} />
    <div className="search-panel">
      <div className="search-input-wrap"><Search size={20} /><input autoFocus value={query} onChange={(event) => setQuery(event.target.value)} placeholder="O que você está procurando?" aria-label="O que você está procurando?" /><button className="icon-button" onClick={onClose} aria-label="Fechar busca"><X /></button></div>
      <p className="search-hint">Busque por macacão, legging, top, short, azul ou preto.</p>
      <div className="search-results">
        {results.map((product) => <Link onClick={onClose} key={product.id} to={`/produto/${product.slug}`}><img src={imageSource(product.images[0])} alt="" /><span><small>{product.collection}</small>{product.name}</span><ArrowRight size={17} /></Link>)}
        {!results.length && <p>Nenhuma sugestão encontrada.</p>}
      </div>
    </div>
  </div>;
}
